<template>
  <div class="page-tab deposit-info-container" style="height: 600px">
    <SchemaTablePage
      show-summary
      :form-props="{ labelPosition: 'left' }"
      ref="tablePageRef"
      layout-mode="dialog"
      :immediate="false"
      :search-schema="searchSchema"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #table-content="{ tableProps, tableData, loading }">
        <el-table v-loading="loading" :data="tableData" v-bind="tableProps" border stripe size="small" style="width: 100%" show-summary :summary-method="getSummaries">
          <el-table-column :resizable="false" prop="orderNo" label="订单号" width="180"></el-table-column>
          <el-table-column :resizable="false" prop="thirdOrderNo" label="三方订单号" width="180"></el-table-column>
          <el-table-column :resizable="false" prop="orderAmount" label="订单金额" width="90">
            <template slot-scope="scope"> {{ scope.row.orderAmount | centsToYuan }} </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="arrivalAmount" label="到账金额" width="90">
            <template slot-scope="scope"> {{ scope.row.arrivalAmount | centsToYuan }}</template>
          </el-table-column>
          <el-table-column :resizable="false" prop="topUpAmount" label="上分金额" width="90">
            <template slot-scope="scope"> {{ scope.row.topUpAmount | centsToYuan }}</template>
          </el-table-column>
          <el-table-column :resizable="false" prop="depositDiscount" label="存款优惠" width="90">
            <template slot-scope="scope"> {{ scope.row.depositDiscount | centsToYuan }}</template>
          </el-table-column>
          <el-table-column :resizable="false" prop="paymentMethod" label="支付方式" width="120"></el-table-column>
          <el-table-column :resizable="false" prop="orderTime" label="订单时间" width="150"></el-table-column>
          <el-table-column :resizable="false" prop="completionTime" label="完成时间" width="150"></el-table-column>
          <el-table-column :resizable="false" prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="getStatusType(scope.row.status)">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="remark" label="备注" min-width="150"></el-table-column>
          <el-table-column :resizable="false" prop="operator" label="操作人" width="110"></el-table-column>
        </el-table>
      </template>
    </SchemaTablePage>
  </div>
</template>

<script>
import SchemaTablePage from '@/components/SchemaTablePage'
import { getPayinHistory } from '@/api/finance/moneyManagement'
import { centsToYuan, yuanToCents } from '@/utils/amount'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'

export default {
  name: 'ManageDepositInfoTabV2',
  components: { SchemaTablePage },
  props: {
    resetKey: { type: Number, default: 0 },
    targetInfo: { type: Object, default: () => ({}) },
    uid: { type: Number, default: 0 },
    isActive: { type: Boolean, default: false },
  },
  data() {
    return {
      defaultQuery: {
        status: 0,
        order_id: '',
        third_order_id: '',
        dateRange: [],
      },
      searchSchema: [
        {
          prop: 'order_id',
          label: '订单号',
          component: 'input',
          componentProps: { placeholder: '请输入订单号', clearable: true },
        },
        {
          prop: 'third_order_id',
          label: '三方订单号',
          component: 'input',
          componentProps: { placeholder: '请输入三方订单号', clearable: true },
        },
        {
          prop: 'status',
          label: '订单状态',
          component: 'select',
          componentProps: { placeholder: '请选择订单状态', clearable: true },
          options: [
            { label: '全部', value: 0 },
            { label: '待确认', value: 1 },
            { label: '存款成功', value: 5 },
            { label: '失败', value: 4 },
          ],
        },
        {
          prop: 'dateRange',
          label: '订单时间',
          component: 'datetime-range',
          componentProps: { clearable: true },
          span: { xs: 24, sm: 12, md: 16, lg: 8, xl: 6 },
        },
        {
          component: 'actions',
          span: { lg: 4 },
        },
      ],
    }
  },
  computed: {
    request() {
      return params => {
        if (!this.targetInfo?.username) {
          return Promise.resolve({ code: 0, data: { list: [], total: 0 } })
        }
        return getPayinHistory(params)
      }
    },
    buildParams() {
      return ({ query, page, limit }) => {
        const username = this.targetInfo?.username || ''
        return {
          page,
          page_size: limit,
          username,
          status: query?.status ?? 0,
          order_id: query?.order_id || '',
          third_order_id: query?.third_order_id || '',
          start_at: query?.dateRange?.[0] ? toUnixSeconds(query.dateRange[0]) : 0,
          end_at: query?.dateRange?.[1] ? toUnixSeconds(query.dateRange[1]) : 0,
          order_amount_start: 0,
          order_amount_end: 0,
          payment_channel: '',
        }
      }
    },
    parseResult() {
      return res => {
        if (res && res.code === 0 && res.data) {
          const list = res.data.list || []
          return {
            list: list.map(item => ({
              orderNo: item.order_id ?? item.id ?? '',
              thirdOrderNo: item.third_order_id || '',
              orderAmount: item.amount,
              arrivalAmount: item.real_amount,
              topUpAmount: item.gold,
              depositDiscount: item.bonus_gold,
              paymentMethod: item.payment_channel_name || '',
              orderTime: formatTimestamp(item.created_at),
              completionTime: formatTimestamp(item.notify_at),
              status: this.mapStatusText(item.status),
              remark: item.remark || '',
              operator: item.operator || '',
            })),
            total: res.data.total || 0,
          }
        }
        this.$message.error(res?.msg || res?.message || '获取充值记录失败')
        return { list: [], total: 0 }
      }
    },
  },
  watch: {
    resetKey() {
      this.$nextTick(() => this.$refs.tablePageRef?.reset?.())
    },
    isActive: {
      handler(v) {
        if (!v) return
        if (!this.targetInfo?.username) return
        this.$nextTick(() => this.$refs.tablePageRef?.reload?.())
      },
      immediate: true,
    },
  },
  methods: {
    mapStatusText(status) {
      const map = {
        1: '待确认',
        2: '自动处理中',
        4: '发货失败',
        5: '存款成功',
        6: '已退款',
      }
      return map[status] || '未知状态'
    },
    getStatusType(statusText) {
      if (statusText === '存款成功') return 'success'
      if (statusText === '待确认') return 'warning'
      if (statusText === '发货失败') return 'danger'
      return 'info'
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计（当前页）'
          return
        }
        if (['orderAmount', 'arrivalAmount', 'topUpAmount', 'depositDiscount'].includes(column.property)) {
          const values = data.map(item => Number(item[column.property]) || 0)
          const s = values.reduce((a, b) => a + b, 0)
          sums[index] = s ? centsToYuan(s) : 0
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
  },
}
</script>
